import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export default function SubControlBar({ children }: Props) {
  return (
    <div className="relative z-0 rounded-tr bg-slate-300 pb-2 pr-8 pt-3">
      <div className="absolute bottom-0 left-0 right-6 top-1 -z-10 bg-black" />
      <div className="absolute bottom-6 right-0 h-1 w-6 bg-black" />
      <div className="absolute bottom-4 right-0 h-1 w-6 bg-black" />
      <div className="absolute bottom-2 right-0 h-1 w-6 bg-black" />
      <div className="absolute bottom-0 right-0 h-1 w-6 bg-black" />

      <div className="scrollbar-hide flex items-start justify-between overflow-auto">
        {children}
      </div>
    </div>
  );
}
